import { createSelector } from 'reselect'
import { LO } from '../../constants/agent_types'
import { selectSponsorship } from './sponsorship'
import {
  getCustomerPhotoUri,
  selectCustomerType,
  selectCustomerProfile,
  selectHomebotNetworkEnabled
} from './customerProfile'
import { selectPreferredLoanOfficerMembership } from './clientTeamMemberships'

export const selectLO = createSelector(
  selectCustomerType,
  selectCustomerProfile,
  selectSponsorship,
  selectHomebotNetworkEnabled,
  selectPreferredLoanOfficerMembership,
  (type, cp, sponsor, hbnEnabled, preferredLOMembership) => {
    // If customer IS a loan officer, use their profile
    if (type === LO) {
      return cp
    }

    // If HBN enabled and preferred LO exists (verified or unverified), use preferred LO
    if (hbnEnabled && preferredLOMembership) {
      // Map preferred LO membership to customer profile format
      return {
        ...preferredLOMembership.customerProfile,
        mobilePhone: preferredLOMembership.customerProfile.phone
      }
    }

    // If HBN enabled but no preferred LO, use customer profile (suppress sponsor)
    if (hbnEnabled) {
      return cp
    }

    // Fallback: use sponsor (when HBN disabled)
    return sponsor
  }
)

export const selectLoanOfficerPhotoUri = createSelector(selectLO, getCustomerPhotoUri)
